module.exports = __webpack_public_path__ + "img/anon.f342d9fc.jpg";